import { createStore } from './store';

export const AppStore = createStore({
  cart: [],
  isShowCart: false,
  orderList: [],
  statistic: [],
  customerInfo: {},
});

export const useAppStore = AppStore.useStore;
